import { Map as ImmutableMap } from 'immutable';

/**
 * Timezones that do not want to be listed along with
 * other countries/cities in the same timezone offset due to geo-politics
 * https://issues.hubspotcentral.com/browse/SMMC-6458
 */
export default ImmutableMap({
  'Asia/Yerevan': 'Yerevan'
});